// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Font sizes */
    --ds-font-size-base: 16px;
    --ds-font-size-xxs: 0.625rem; /* 10px */
    --ds-font-size-xs: 0.75rem; /* 12px */
    --ds-font-size-s: 0.875rem; /* 14px */
    --ds-font-size-m: 1rem; /* 16px */
    --ds-font-size-l: 1.125rem; /* 18px */
    --ds-font-size-xl: 1.25rem; /* 20px */
    --ds-font-size-2xl: 1.5rem; /* 24px */
    --ds-font-size-3xl: 1.75rem; /* 28px */
    --ds-font-size-4xl: 2.25rem; /* 36px */
    --ds-font-size-5xl: 3rem; /* 48px */
    /* Line heights */
    --ds-line-height-heading: 112%;
    --ds-line-height: 100%;
    --ds-line-height-paragraph: 125%;
    --ds-line-height-big: var(--ds-6x);
    --ds-line-height-medium: var(--ds-5x);
    --ds-line-height-small: var(--ds-4x);
    /* Font colors */
    --ds-font-color: var(--ds-color-grey-20);
    --ds-font-color-accent: var(--ds-color-grey-10);
    --ds-font-color-alert: var(--ds-color-alert);
    --ds-font-color-informative: var(--ds-color-informative);
    --ds-font-color-inverted: var(--ds-color-grey-100);
    --ds-font-color-muted: var(--ds-color-grey-30);
    --ds-font-color-negative: var(--ds-color-negative);
    --ds-font-color-positive: var(--ds-color-positive);
    /* Font family */
    --ds-font-family: 'Aeonik';
    --ds-font-family-mono:
        'JetBrains Mono', ui-monospace, 'SF Mono', 'Menlo', 'Consolas',
        monospace;
    /* Font weights */
    --ds-font-weight-regular: 400;
    --ds-font-weight-medium: 500;
    --ds-font-weight-bold: 700;
    /* Letter spacing */
    --ds-letter-spacing-subtitle: 0.0625rem;
    /* Aliases */
    --ds-heading-1: var(--ds-font-size-5xl);
    --ds-heading-2: var(--ds-font-size-4xl);
    --ds-heading-3: var(--ds-font-size-3xl);
    --ds-heading-4: var(--ds-font-size-2xl);
    --ds-heading-5: var(--ds-font-size-l);
    --ds-subtitle: var(--ds-font-size-xs);
    --ds-text-2Xlarge: var(--ds-font-size-2xl);
    --ds-text-xlarge: var(--ds-font-size-xl);
    --ds-text-large: var(--ds-font-size-l);
    --ds-text: var(--ds-font-size-m);
    --ds-text-small: var(--ds-font-size-s);
    --ds-text-tiny: var(--ds-font-size-xs);
    --ds-text-micro: var(--ds-font-size-xxs);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
